<main class="main-container">
  <app-header class=""></app-header>
  <app-toolbar class=""></app-toolbar>

  <div class="planning w-full min-w-[900px]">
    <!-- <app-toolbar-services></app-toolbar-services> -->

    <div class="planning-table grid-flow-row border-r-[3px] border-[#27368A]">
      <div class="card relative">
        <ng-container *ngIf="viewTab['months']">
          <div class="absolute right-[7px] top-[7px] z-10">
            <div class="relative">
              <p-calendar [(ngModel)]="pickerDate" view="month" dateFormat="mm/yy" [readonlyInput]="true"
                inputId="picker-calendar" (onSelect)="selectDateOnCalendar($event)"
                [style.display]="showCalendar ? 'block' : 'none'" [style.width]="'400px'" [inline]="true"
                #calendar></p-calendar>

              <label (click)="manageCalendar($event)" #btnOpenCalendar
                class="bg-[#429DCF] text-white text-[20px] font-[600] rounded-[12px] px-[14px] py-[9px] flex gap-2 items-center mb-3 cursor-pointer">
                <img src="/assets/icons/icon-calendar.png" class="w-[29px]" alt="" />
                Mes
                <img src="/assets/icons/arrow-down.png" class="w-[13px] pt-1" alt="" />
              </label>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="viewTab['days']">
          <div class="absolute right-[7px] top-[7px] z-10">
            <div class="relative">
              <p-calendar [(ngModel)]="pickerDate" view="date" dateFormat="dd/mm/yy" [readonlyInput]="true"
                inputId="picker-calendar" (onSelect)="selectDateOnCalendar($event)"
                [style.display]="showCalendar ? 'block' : 'none'" [style.width]="'400px'" [inline]="true"
                #calendar></p-calendar>

              <label (click)="manageCalendar($event)" #btnOpenCalendar
                class="bg-[#429DCF] text-white text-[20px] font-[600] rounded-[12px] px-[14px] py-[9px] flex gap-2 items-center mb-3 cursor-pointer">
                <img src="/assets/icons/icon-calendar.png" class="w-[29px]" alt="" />
                Día
                <img src="/assets/icons/arrow-down.png" class="w-[13px] pt-1" alt="" />
              </label>
            </div>
          </div>
        </ng-container>

        <p-tabView [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event)">
          <p-tabPanel header="Planning">
            <div class="calendar-controls flex items-center justify-between mb-4">
              <ng-container *ngIf="viewTab['months']">
                <div class="flex gap-2 items-center">
                  <div class="flex gap-4 items-center">
                    <button type="button" (click)="getTodayDate()"
                      class="py-[7px] px-[15px] border-[1px] border-solid border-[#A3A3A3] rounded-[12px] font-[800] text-[15px] text-[#5C5C5C]">
                      Mes actual
                    </button>
                  </div>
                  <div class="flex gap-2 items-center">
                    <div (click)="onSubtractToDate()"
                      class="bg-[#429DCF] text-white px-1 pb-[3px] h-[20px] rounded-[5px] font-[800] text-[15px] leading-[1.2] cursor-pointer select-none">
                      &lt;
                    </div>
                    <div (click)="onAddToDate()"
                      class="bg-[#429DCF] text-white px-1 pb-[3px] h-[20px] rounded-[5px] font-[800] text-[15px] leading-[1.2] cursor-pointer select-none">
                      &gt;
                    </div>
                  </div>
                  <p class="ml-[20px] font-[800] text-[#5C5C5C] text-[15px]">
                    {{ selectedMonthString | PCustomMonthFormat }}
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="viewTab['days']">
                <div class="flex gap-2 items-center">
                  <div class="flex gap-4 items-center">
                    <button type="button" (click)="getTodayDate()"
                      class="py-[7px] px-[15px] border-[1px] border-solid border-[#A3A3A3] rounded-[12px] font-[800] text-[15px] text-[#5C5C5C]">
                      Hoy
                    </button>
                  </div>
                  <div class="flex gap-2 items-center">
                    <div (click)="onSubtractToDate()"
                      class="bg-[#429DCF] text-white px-1 pb-[3px] h-[20px] rounded-[5px] font-[800] text-[15px] leading-[1.2] cursor-pointer select-none">
                      &lt;
                    </div>
                    <div (click)="onAddToDate()"
                      class="bg-[#429DCF] text-white px-1 pb-[3px] h-[20px] rounded-[5px] font-[800] text-[15px] leading-[1.2] cursor-pointer select-none">
                      &gt;
                    </div>
                  </div>
                  <p class="ml-[20px] font-[800] text-[#5C5C5C] text-[15px]">
                    {{ selectedDayString | PCustomDayFormat }}
                  </p>
                </div>
              </ng-container>

              <div class="container-filter-select" *ngIf="viewTab['months'] || viewTab['days']">
                <select name="" (change)="filterTable($event)" #filterSelectServices>
                  <option value="all">Todos los servicios</option>
                  <ng-container *ngFor="let serviceGroup of dataFilterPlaning">
                    <option [value]="serviceGroup.name">
                      {{ serviceGroup.name }}
                    </option>
                  </ng-container>
                </select>
              </div>

              <ng-container *ngIf="viewTab['days']">
                <div class="flex gap-4 items-center content-between cursor-pointer"
                  (click)="handleChangeView($event, 'months')">
                  <img src="/assets/icons/arrow-back-outline.png" alt="" />
                  <span class="text-[#5C5C5C] text-[15px] font-[800]">Volver atras</span>
                </div>
              </ng-container>

              <ng-container *ngIf="viewTab['hours']">
                <div class="flex gap-4 items-center content-between cursor-pointer ml-auto"
                  (click)="handleChangeView($event, 'days')">
                  <img src="/assets/icons/arrow-back-outline.png" alt="" />
                  <span class="text-[#5C5C5C] text-[15px] font-[800]">Volver atras</span>
                </div>
              </ng-container>
            </div>
<!-- id="container-table-date-bs" -->
            <div class="relative overflow-x-auto rounded-[8px] mb-10" *ngIf="viewTab['months']">
              <p-table [value]="dateDaysTableFiltered" [scrollable]="true" scrollHeight="600px" styleClass="w-full text-sm text-left rtl:text-right text-gray-500"  >
                <ng-template pTemplate="header">
                  <tr class="">
                    <th scope="col" class="px-6 py-3 w-[70px] text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">Día</th>
                    <th scope="col" class="px-6 py-3 text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">Nº Actividades</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dataDay >
                  <ng-container *ngIf="
                      dateDaysTableFiltered && dateDaysTableFiltered.length;
                    ">
                    <!-- <ng-container *ngFor="let dataDay of dateDaysTableFiltered"> -->


                      <tr class="text-[#383838] text-[15px] font-[300] border-b-[3px] border-[#E6E6E6] bg-[#F4F4F4]"  [ngClass]="{'bg-red-100 border-red-200': validateDayHasPassed(dataDay['date']) }">
                        <td scope="row"
                          class="px-6 py-4 whitespace-nowrap border-r-[3px] border-[#E6E6E6]  border-solid"  [ngClass]="{'border-red-200': validateDayHasPassed(dataDay['date']) }">
                          {{ dataDay["date"] }}
                        </td>
                        <td class="px-6 py-4">
                          <div class="booking-services-container flex flex-wrap relative pr-20">
                            <ng-container *ngFor="
                                let planninGroupNameDay of dataDay['data']
                                  | keyvalue
                              ">
                              <div
                                class="flex align-items-center bg-white rounded-[7.5px] border border-gray-200 p-2 m-1">
                                <div class="p-1">
                                  <label class="custom-checkbox">
                                    <input type="checkbox" class="cb-bs" [attr.data-hour-service]="
                                        dataDay.date +
                                        '---/---' +
                                        planninGroupNameDay.key
                                      " (click)="
                                        toggleOptionCB(
                                          dataDay.date +
                                            '---/---' +
                                            planninGroupNameDay.key
                                        )
                                      " [checked]="
                                        CBBookingService.includes(
                                          dataDay.date +
                                            '---/---' +
                                            planninGroupNameDay.key
                                        )
                                      " />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                                <div class="grow px-2 pb-2 text-[14px] font-[700]">
                                  <p class="text-nowrap">
                                    {{ planninGroupNameDay.key }}
                                  </p>
                                  <p>
                                    x{{
                                    countBookingServicesUnits(
                                      dataDay['date'],
                                      planninGroupNameDay.key
                                    )
                                    }}
                                  </p>
                                  <table>
                                    <thead class="border-b border-[silver]">
                                      <th class="font-bold p-2">Servicios</th>
                                      <th class="font-bold p-2">Grupos</th>
                                      <ng-container *ngIf="planninGroupNameDay.key == 'Descenso canoa por el rio Sella'">
                                        <th class="font-bold p-2">Punto de recogida</th>
                                      </ng-container>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="align-top p-2" [innerHTML]="
                                        serviceProfileQuantityList(
                                          dataDay['date'],
                                          planninGroupNameDay.key
                                        )
                                      "></td>
                                        <td class="align-top p-2" [innerHTML]="
                                        customersGroupQuantityList(
                                          dataDay['date'],
                                          planninGroupNameDay.key
                                        )
                                      "></td>
                                      <ng-container *ngIf="planninGroupNameDay.key == 'Descenso canoa por el rio Sella'">
                                        <td class="align-top p-2" [innerHTML]="
                                          collectionPointQuantityList(
                                            dataDay['date'],
                                            planninGroupNameDay.key
                                          )
                                        "></td>
                                      </ng-container>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="flex items-end p-1">
                                  <button (click)="
                                      openBookingByDateServiceDialog(
                                        dataDay['date'],
                                        planninGroupNameDay.key
                                      )
                                    " type="button" class="bg-[#429DCF] rounded-[6.4px] p-1">
                                    <img src="/assets/icons/icon_eye.png" class="w-[15px]" />
                                  </button>
                                </div>
                              </div>

                              <button type="button" *ngIf="
                                  Object.entries(dataDay['data']).length > 0
                                " (click)="
                                  handleChangeView(
                                    $event,
                                    'days',
                                    dataDay['date']
                                  )
                                "
                                class="cursor-pointer absolute right-[5px] top-[5px] bg-[#429DCF] rounded-[12px] text-white font-[600] text-[15px] px-5 pt-[7px] pb-[7px]">
                                Zoom
                              </button>
                            </ng-container>
                          </div>
                        </td>
                      </tr>
                    <!-- </ng-container> -->
                  </ng-container>

                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr class="text-[#383838] text-[15px] font-[300] border-b-[3px] border-[#E6E6E6] bg-[#F4F4F4]">
                    <td scope="row" class="px-6 py-4 whitespace-nowrap text-center" colspan="2">
                      No existen datos
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <div class="relative overflow-x-auto rounded-[8px] mb-10" *ngIf="viewTab['days']">
              <p-table  [value]="dateHoursTableFiltered" [scrollable]="true" scrollHeight="600px" styleClass="w-full text-sm text-left rtl:text-right text-gray-500" id="container-table-date-bs">
                <ng-template pTemplate="header">
                  <tr>
                    <th scope="col" class="px-6 py-3 w-[70px] text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">Hora</th>
                    <th scope="col" class="px-6 py-3 text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]" >Nº Actividades</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dataHour>
                  <ng-container *ngIf="
                      dateHoursTableFiltered && dateHoursTableFiltered.length > 0;

                    ">
                    <!-- <ng-container *ngFor="let dataHour of dateHoursTableFiltered"> -->
                      <tr class="text-[#383838] text-[15px] font-[300]  border-b-[3px] border-[#E6E6E6] bg-[#F4F4F4]">
                        <td scope="row"
                          class="px-6 py-4 whitespace-nowrap border-r-[3px] border-[#E6E6E6] border-solid">
                          {{ dataHour["hour"] }}
                        </td>
                        <td class="px-6 py-4">
                          <div class="booking-services-container flex flex-wrap relative pr-20">
                            <ng-container *ngFor="
                                let serviceHour of dataHour['data'] | keyvalue
                              ">
                              <div class="" [ngClass]="{
                                  'bg-red-200 border border-red-300':
                                    validateDateStatus(
                                      dataHour['hour'],
                                      serviceHour.key
                                    ),
                                  'flex align-items-center rounded-[7.5px] p-2 m-1 relative': true,
                                  'bg-white border border-gray-200':
                                    !validateDateStatus(
                                      dataHour['hour'],
                                      serviceHour.key
                                    )
                                }">
                                <ng-container *ngIf="canChangeStatusService">
                                  <ng-container *ngIf="
                                      validateDateStatus(
                                        dataHour['hour'],
                                        serviceHour.key
                                      )
                                    ">
                                    <img (click)="
                                        deleteDateFromBlock(
                                          dataHour['hour'],
                                          serviceHour.key
                                        )
                                      "
                                      class="absolute right-[5px] top-[5px] w-[17px] cursor-pointer bg-white rounded-full"
                                      src="./assets/svg/check-icon.svg" alt="" />
                                  </ng-container>
                                  <ng-container *ngIf="
                                      !validateDateStatus(
                                        dataHour['hour'],
                                        serviceHour.key
                                      )
                                    ">
                                    <img (click)="
                                        addDateToBlock(
                                          dataHour['hour'],
                                          serviceHour.key
                                        )
                                      "
                                      class="absolute right-[5px] top-[5px] w-[17px] cursor-pointer bg-white rounded-full"
                                      src="./assets/svg/block-icon.svg" alt="" />
                                  </ng-container>
                                </ng-container>

                                <div class="p-1">
                                  <label class="custom-checkbox">
                                    <input type="checkbox" class="cb-bs" [attr.data-hour-service]="
                                        dataHour['hour'] +
                                        '---/---' +
                                        serviceHour.key
                                      " (click)="
                                        toggleOptionCB(
                                          dataHour['hour'] +
                                            '---/---' +
                                            serviceHour.key
                                        )
                                      " [checked]="
                                        CBBookingService.includes(
                                          dataHour['hour'] +
                                            '---/---' +
                                            serviceHour.key
                                        )
                                      " />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                                <div class="grow px-2 pb-2 text-[14px] font-[700]">
                                  <p class="text-nowrap">
                                    {{ serviceHour.key }}
                                  </p>
                                  <p>
                                    x{{
                                    countBookingServicesUnits(
                                      dataHour['hour'],
                                      serviceHour?.key
                                    )
                                    }}
                                  </p>
                                  <table>
                                    <thead class="border-b border-[silver]">
                                      <th class="font-bold p-2">Servicios</th>
                                      <th class="font-bold p-2">Grupos</th>
                                      <ng-container *ngIf="serviceHour.key == 'Descenso canoa por el rio Sella'">
                                        <th class="font-bold p-2">Punto de recogida</th>
                                      </ng-container>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="align-top p-2" [innerHTML]="
                                          serviceProfileQuantityList(
                                            dataHour['hour'],
                                            serviceHour.key
                                          )
                                        "></td>
                                        <td class="align-top p-2" [innerHTML]="
                                          customersGroupQuantityList(
                                            dataHour['hour'],
                                            serviceHour.key
                                          )
                                        "></td>
                                        <ng-container *ngIf="serviceHour.key == 'Descenso canoa por el rio Sella'">
                                          <td class="align-top p-2" [innerHTML]="
                                          collectionPointQuantityList(
                                            dataHour['hour'],
                                            serviceHour.key
                                          )
                                        "></td>
                                        </ng-container>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="flex items-end p-1">
                                  <button (click)="
                                      openBookingByDateServiceDialog(
                                        dataHour['hour'],
                                        serviceHour.key
                                      )
                                    " type="button" class="bg-[#429DCF] rounded-[6.4px] p-1">
                                    <img src="/assets/icons/icon_eye.png" class="w-[15px]" />
                                  </button>
                                </div>
                              </div>
                            </ng-container>

                            <button type="button" *ngIf="
                                Object.entries(dataHour['data']).length > 0
                              " (click)="
                                handleChangeView(
                                  $event,
                                  'hours',
                                  dataHour['hour']
                                )
                              "
                              class="cursor-pointer absolute right-[5px] top-[5px] bg-[#429DCF] rounded-[12px] text-white font-[600] text-[15px] px-5 pt-[7px] pb-[7px]">
                              Zoom
                            </button>
                          </div>
                        </td>
                      </tr>
                    <!-- </ng-container> -->
                  </ng-container>

                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr class="text-[#383838] text-[15px] font-[300] border-b-[3px] border-[#E6E6E6] bg-[#F4F4F4]">
                    <td scope="row" class="px-6 py-4 whitespace-nowrap text-center" colspan="2">
                      No existen datos
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <div class="relative overflow-x-auto rounded-[8px] mb-10" *ngIf="viewTab['hours']">
              <table class="w-full text-sm text-left rtl:text-right text-gray-500" id="container-table-date-bs">
                <thead class="text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">
                  <tr>
                    <th scope="col" class="px-6 py-3 w-[70px]">Hora</th>
                    <th scope="col" class="px-6 py-3">Nº Actividades</th>
                  </tr>
                </thead>
                <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
                  <ng-container *ngIf="
                      selectedBookings && selectedBookings.length > 0;
                      else noDataHour
                    ">
                    <tr class="text-[#383838] text-[15px] font-[300]">
                      <td scope="row" class="px-6 py-4 whitespace-nowrap border-r-[3px] border-[#E6E6E6] border-solid">
                        {{ selectedHourString }}
                      </td>
                      <td class="px-6 py-4">
                        <ng-container *ngFor="let booking of selectedBookings">
                          <div class="booking-services-container flex flex-col relative pr-20">
                            <div
                              class="flex align-items-center bg-white rounded-[7.5px] border border-gray-200 w-full p-2 m-1">
                              <div class="grow px-3 pb-3 pt-2 text-[14px] font-[700]">
                                <p class="text-[22px] font-[700] text-[#27368A] mb-[2px]">
                                  {{ booking.reference }}
                                </p>
                                <p class="text-[16px] font-[700] text-[#534848] mb-[4px]">
                                  {{ getUnitsFromBookingByHour(booking, selectedHourString) }} Persona(s) -
                                  {{ booking.customer.name }} -
                                  {{ booking.customer.cif }}
                                </p>
                                <p class="text-[16px] font-[700] text-[#534848]">
                                  {{ booking.office.name }}
                                </p>
                                <h5>Actividades:</h5>
                                <p *ngFor="let bookingService of booking.services">
                                  <span class="font-bold">{{ bookingService.service_profile.service.name }} - {{ bookingService.service_profile.name }} - x{{ bookingService.units }}</span>
                                </p>

                              </div>
                              <div class="flex flex-col p-3">
                                <button type="button" (click)="
                                    openBookingByHourDialog(
                                      booking.id,
                                      booking.reference
                                    )
                                  "
                                  class="bg-[#429DCF] rounded-[14px] text-[18px] font-[600] text-white px-[30px] py-[10px] mb-2">
                                  Consultar
                                </button>
                                <button type="button" disabled="true" class="{{
                                    booking.status_color
                                  }} text-[18px] font-[600] text-white px-[30px] py-[10px]">
                                  {{ booking.status_name }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>

                  <ng-template #noDataHour>
                    <tr class="text-[#383838] text-[15px] font-[300]">
                      <td scope="row" class="px-6 py-4 whitespace-nowrap text-center" colspan="2">
                        No existen datos
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>

          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
    <div>
      <div class="header-inventory">
        <ul>
          <li>Inventario</li>
        </ul>
      </div>
      <div class="body-inventory p-[1rem]">
        <div class="relative overflow-x-auto rounded-[8px]">
          <table class="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead class="text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">
              <tr>
                <th scope="col" class="px-6 py-3">Items</th>
                <th scope="col" class="px-6 py-3">Cantidad</th>
              </tr>
            </thead>
            <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
              <ng-container *ngIf="selectedItems.length > 0; else noDataItems">
                <tr class="text-[#383838] text-[15px] font-[300]" *ngFor="let item of selectedItems">
                  <td scope="row" class="px-6 py-4 whitespace-nowrap">
                    {{ item.name }} - {{ item.size }}
                  </td>
                  <td class="px-6 py-4">x{{ item.units }}</td>
                </tr>
              </ng-container>
              <ng-template #noDataItems>
                <tr class="text-[#383838] text-[15px] font-[300]">
                  <td scope="row" colspan="2" class="px-6 py-4 whitespace-nowrap text-center">
                    No hay items existentes
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</main>
<!-- dialog ver bookings por hora: planning -->
<p-dialog [header]="headerBookingsByHourDialog" [(visible)]="showBookingByHour" [modal]="true"
  [style]="{ width: '90%', maxWidth: '450px' }" [draggable]="false" [resizable]="false">
  <section class="flex flex-col gap-5">
    <button class="bg-[#429DCF] rounded-[14px] text-[18px] font-[600] text-white px-[30px] py-[10px] mb-1 block"
      [routerLink]="['/panel/bookings/edit', bookingIdToEdit]">
      Ver booking
    </button>
    <button *ngIf="enableBtnGenerateAmount"
      class="bg-[#429DCF] rounded-[14px] text-[18px] font-[600] text-white px-[30px] py-[10px] mb-1 block"
      [routerLink]="['/panel/payments', bookingIdToEdit]">
      Generar importe
    </button>
  </section>
</p-dialog>

<!-- dialog ver bookings por hora y sevicio: planning -->
<p-dialog [header]="headerBookingsByDateServiceDialog" [(visible)]="showBookingByDateService" [modal]="true"
  [style]="{ width: '95%', maxWidth: '1200px' }" [draggable]="false" [resizable]="false">
  <div class="relative overflow-x-auto rounded-[8px]">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500">
      <thead class="text-[15px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">
        <tr>
          <th scope="col" class="px-6 py-3">Referencia</th>
          <th scope="col" class="px-6 py-3">Pagado</th>
          <th scope="col" class="px-6 py-3">Total</th>
          <th scope="col" class="px-6 py-3">Tickets</th>
          <th scope="col" class="px-6 py-3">Items</th>
          <th scope="col" class="px-6 py-3">Estado</th>
        </tr>
      </thead>
      <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
        <ng-container *ngIf="selectedBookings">
          <tr class="text-[#383838] text-[15px] font-[300]" *ngFor="let booking of selectedBookings">
            <td scope="row" class="px-6 py-4 whitespace-nowrap font-bold">
              <p>{{ booking.reference }}</p>
              <p>{{ booking.customer.name }}</p>
              <div [innerHTML]="returnAddressFromBooking(booking)"></div>
            </td>
            <td class="px-6 py-4">{{ booking.total_paid }}€</td>
            <td class="px-6 py-4">{{ booking.total_amount }}€</td>
            <td class="px-6 py-4">{{ booking.total_units }}</td>
            <td class="px-6 py-4" [innerHTML]="returnItemsByBooking(booking)"></td>
            <td class="px-6 py-4">
              <span class="inline-block text-nowrap {{ booking.status_color }} py-1 px-5 rounded-[12px] text-white font-bold">{{ booking.status_name }}</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</p-dialog>
